import React from 'react';
import styles from './aboListing/AboListing.module.scss';

const DeleteConfirmationModal = (props) => {
  const {
    isDeleteRecord,
    handleCloseDeleteModal,
    selectedAboList,
    selectedCourse,
    handleDeleteInput,
    handleDeleteImage,
    input,
    handleDeleteRecord,
    notificationData,
    ImageDetail,
    ModalWrapper,
    Background,
    Notification,
  } = props;
  return (
    <>
      {isDeleteRecord ? (
        <div className={[styles.modal_wrapper, ''].join(' ')}>
          <Background backgroundFlag="small">
            <ModalWrapper modalFlag="small">
              {/* <div className={styles.delete_modal}> */}
              <div className={styles.header_wrapper}>
                <div className={styles.heading}>Delete Learning Record?</div>
                <div className={styles.close_wrapper} onClick={() => handleCloseDeleteModal()}>
                  <div className={styles.close_icon} />
                </div>
              </div>
              <>
                <div className={styles.warning_section}>
                  <div className={styles.warning_icon} />
                  <div className={styles.message_section}>
                    <div className={[styles.heading, styles.warning_message, styles.mb_5].join(' ')}>
                        You are about to delete {selectedAboList.length > 1 ? 'Multiple Learning Records' : `${selectedAboList?.[0]?.name}'s Learning Record`} for <span className={styles.text_bold}>{selectedCourse}</span>
                    </div>
                    <div className={styles.sub_heading}>{"You can't undo this action."}</div>
                  </div>
                </div>

                <div className={styles.confirm_wrapper}>
                  <div className={styles.txt}>{`To permanently Delete ${selectedAboList.length > 1 ? 'ALL of the selected Learning Records' : 'this Learning Record'}, type DELETE`}.</div>
                  <div className={styles.input_wrapper}>
                    <input
                      type={'text'}
                      placeholder="Type “DELETE” here"
                      // value={input}
                      onChange={(e) => handleDeleteInput(e.target.value)}
                      onBlur={(e) => handleDeleteImage(e.target.value)}
                      className={[
                        styles.input,
                        input.length > 1 && input.length !== 0 && input !== 'DELETE'
                          ? styles.error_input
                          : '',
                      ].join(' ')}
                    />
                    {input.length > 1 && input.length !== 0 && input !== 'DELETE' ? (
                      <>
                        <div className={styles.error_icon} />
                        <div className={styles.error_msg}>{"Error in character input"}</div>
                      </>
                    ) : null}
                  </div>
                </div>
              </>

              <div className={styles.btn_wrapper}>
                <button className={styles.btn} onClick={() => handleCloseDeleteModal()}>
                  Cancel
                </button>
                <button
                  className={[
                    styles.btn,
                    input.length > 0 && input === 'DELETE' ? styles.active : styles.disabled,
                  ].join(' ')}
                  onClick={() => handleDeleteRecord(ImageDetail?.imageId)}
                >
                {selectedAboList.length > 1 ? 'Delete All' : 'Delete'}
                </button>
              </div>
              {/* </div> */}
            </ModalWrapper>
          </Background>
        </div>
      ) : null}
      {/* Delete Modal */}
      {notificationData && notificationData.show && <Notification />}
    </>
  );
};

export default DeleteConfirmationModal;
